export const personaNFTs = [
             
                {
            id: 'Persona-8045',
            name: 'Persona #8045',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-3369695600519266781.jpeg',
            price: '0.45 ETH'
        },
        {
            id: 'Persona-8044',
            name: 'Persona #8044',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-1344410766950876220.jpeg',
            price: '0.23 ETH'
        },
        {
            id: 'Persona-8043',
            name: 'Persona #8043',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-4165120016894645583.jpeg',
            price: '0.67 ETH'
        },
        {
            id: 'Persona-8042',
            name: 'Persona #8042',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-8949387578378184341.jpeg',
            price: '0.15 ETH'
        },
        {
            id: 'Persona-8041',
            name: 'Persona #8041',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-2998779401717753726.jpeg',
            price: '0.52 ETH'
        },
        {
            id: 'Persona-8040',
            name: 'Persona #8040',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-2953727010370015096.jpeg',
            price: '0.33 ETH'
        },
        {
            id: 'Persona-8039',
            name: 'Persona #8039',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-6400894736701960913.jpeg',
            price: '0.71 ETH'
        },
        {
            id: 'Persona-8038',
            name: 'Persona #8038',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-5645276645583657979.jpeg',
            price: '0.19 ETH'
        },
        {
            id: 'Persona-8037',
            name: 'Persona #8037',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-532328578655598917.jpeg',
            price: '0.58 ETH'
        },
        {
            id: 'Persona-8036',
            name: 'Persona #8036',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-4095069714805185695.jpeg',
            price: '0.27 ETH'
        },
        {
            id: 'Persona-8035',
            name: 'Persona #8035',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-1232062885838698927.jpeg',
            price: '0.64 ETH'
        },
        {
            id: 'Persona-8020',
            name: 'Persona #8020',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-4222938470356683438.jpeg',
            price: '0.12 ETH'
        },
        {
            id: 'Persona-8025',
            name: 'Persona #8025',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-5353698501409135051.jpeg',
            price: '0.48 ETH'
        },
        {
            id: 'Persona-8019',
            name: 'Persona #8019',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-7486012550386369010.jpeg',
            price: '0.31 ETH'
        },
        {
            id: 'Persona-8029',
            name: 'Persona #8029',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-6550549210987200419.jpeg',
            price: '0.75 ETH'
        },
        {
            id: 'Persona-8018',
            name: 'Persona #8018',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-5895054764253360551.jpeg',
            price: '0.17 ETH'
        },
        {
            id: 'Persona-8027',
            name: 'Persona #8027',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-2922843394477517143.jpeg',
            price: '0.55 ETH'
        },
        {
            id: 'Persona-8024',
            name: 'Persona #8024',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-5877585277896503984.jpeg',
            price: '0.25 ETH'
        },
        {
            id: 'Persona-8031',
            name: 'Persona #8031',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-2229640368010627998.jpeg',
            price: '0.69 ETH'
        },
        {
            id: 'Persona-8033',
            name: 'Persona #8033',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-8567148717916213076.jpeg',
            price: '0.14 ETH'
        },
        {
            id: 'Persona-8021',
            name: 'Persona #8021',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-5614727484743454149.jpeg',
            price: '0.51 ETH'
        },
        {
            id: 'Persona-8026',
            name: 'Persona #8026',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1708508308-999939157171544791.gif',
            price: '0.34 ETH'
        },
        {
            id: 'Persona-8023',
            name: 'Persona #8023',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-8841106479725999254.jpeg',
            price: '0.73 ETH'
        },
        {
            id: 'Persona-8032',
            name: 'Persona #8032',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-523531606668918372.jpeg',
            price: '0.18 ETH'
        },
        {
            id: 'Persona-8034',
            name: 'Persona #8034',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1708508308-999939157171544791.gif',
            price: '0.57 ETH'
        },
        {
            id: 'Persona-8022',
            name: 'Persona #8022',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-3181296168989139219.jpeg',
            price: '0.28 ETH'
        },
        {
            id: 'Persona-8030',
            name: 'Persona #8030',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1708508308-999939157171544791.gif',
            price: '0.66 ETH'
        },
        {
            id: 'Persona-8028',
            name: 'Persona #8028',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-1572435388649048068.jpeg',
            price: '0.13 ETH'
        },
        {
            id: 'Persona-8017',
            name: 'Persona #8017',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-2064273219293799214.jpeg',
            price: '0.49 ETH'
        },
        {
            id: 'Persona-8016',
            name: 'Persona #8016',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-4134689301897761298.jpeg',
            price: '0.32 ETH'
        },
        {
            id: 'Persona-8015',
            name: 'Persona #8015',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1708508308-999939157171544791.gif',
            price: '0.77 ETH'
        },
        {
            id: 'Persona-8014',
            name: 'Persona #8014',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-797077979406182044.jpeg',
            price: '0.16 ETH'
        },
        {
            id: 'Persona-8013',
            name: 'Persona #8013',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-1276022758399454783.jpeg',
            price: '0.54 ETH'
        },
        {
            id: 'Persona-8012',
            name: 'Persona #8012',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-2146800455759999255.jpeg',
            price: '0.24 ETH'
        },
        {
            id: 'Persona-8011',
            name: 'Persona #8011',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-4393139134337967560.jpeg',
            price: '0.68 ETH'
        },
        {
            id: 'Persona-8010',
            name: 'Persona #8010',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-533482504851408792.jpeg',
            price: '0.11 ETH'
        },
        {
            id: 'Persona-8009',
            name: 'Persona #8009',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-2132346856532149432.jpeg',
            price: '0.47 ETH'
        },
        {
            id: 'Persona-8008',
            name: 'Persona #8008',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-5173407491958734173.jpeg',
            price: '0.29 ETH'
        },
        {
            id: 'Persona-8007',
            name: 'Persona #8007',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-6142513677949469391.jpeg',
            price: '0.72 ETH'
        },
        {
            id: 'Persona-8006',
            name: 'Persona #8006',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-3345276101626722522.jpeg',
            price: '0.15 ETH'
        },
        {
            id: 'Persona-8005',
            name: 'Persona #8005',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-1648099861989912068.jpeg',
            price: '0.53 ETH'
        },
        {
            id: 'Persona-8004',
            name: 'Persona #8004',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-6743427611575843820.jpeg',
            price: '0.26 ETH'
        },
        {
            id: 'Persona-8003',
            name: 'Persona #8003',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715439-7912300567397352968.jpeg',
            price: '0.65 ETH'
        },
        {
            id: 'Persona-8002',
            name: 'Persona #8002',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-7289898140321261112.jpeg',
            price: '0.12 ETH'
        },
        {
            id: 'Persona-8001',
            name: 'Persona #8001',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-7237714202358944396.jpeg',
            price: '0.46 ETH'
        },
        {
            id: 'Persona-8000',
            name: 'Persona #8000',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-5060259326165204722.jpeg',
            price: '0.30 ETH'
        },
        {
            id: 'Persona-7999',
            name: 'Persona #7999',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-6216352924295547310.jpeg',
            price: '0.74 ETH'
        },
        {
            id: 'Persona-7998',
            name: 'Persona #7998',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-150613119606805118.jpeg',
            price: '0.17 ETH'
        },
        {
            id: 'Persona-7997',
            name: 'Persona #7997',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-6190921246331834992.jpeg',
            price: '0.56 ETH'
        },
        {
            id: 'Persona-7996',
            name: 'Persona #7996',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-2752404093956784456.jpeg',
            price: '0.22 ETH'
        },
        {
            id: 'Persona-7995',
            name: 'Persona #7995',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1708508308-999939157171544791.gif',
            price: '0.63 ETH'
        },
        {
            id: 'Persona-7994',
            name: 'Persona #7994',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-6951851299237749487.jpeg',
            price: '0.10 ETH'
        },
        {
            id: 'Persona-7993',
            name: 'Persona #7993',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1708508308-999939157171544791.gif',
            price: '0.44 ETH'
        },
            {
            id: 'Persona-7992',
            name: 'Persona #7992',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-8617531872594830712.jpeg',
            price: '0.28 ETH'
        },
        {
            id: 'Persona-7991',
            name: 'Persona #7991',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-570919986172120191.jpeg',
            price: '0.67 ETH'
        },
        {
            id: 'Persona-7990',
            name: 'Persona #7990',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-22614824324479311.jpeg',
            price: '0.15 ETH'
        },
        {
            id: 'Persona-7989',
            name: 'Persona #7989',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-8329900179684895931.jpeg',
            price: '0.52 ETH'
        },
        {
            id: 'Persona-7988',
            name: 'Persona #7988',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-3684205208671863509.jpeg',
            price: '0.33 ETH'
        },
        {
            id: 'Persona-7987',
            name: 'Persona #7987',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-1338853697458964357.jpeg',
            price: '0.71 ETH'
        },
        {
            id: 'Persona-7986',
            name: 'Persona #7986',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-5001610797926715023.jpeg',
            price: '0.19 ETH'
        },
        {
            id: 'Persona-7985',
            name: 'Persona #7985',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-5833919086233561846.jpeg',
            price: '0.58 ETH'
        },
        {
            id: 'Persona-7984',
            name: 'Persona #7984',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-3207820841276099382.jpeg',
            price: '0.27 ETH'
        },
        {
            id: 'Persona-7983',
            name: 'Persona #7983',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-3673879406970171142.jpeg',
            price: '0.64 ETH'
        },
        {
            id: 'Persona-7981',
            name: 'Persona #7981',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-2580515537014061786.jpeg',
            price: '0.12 ETH'
        },
        {
            id: 'Persona-7982',
            name: 'Persona #7982',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-784205518016261870.jpeg',
            price: '0.48 ETH'
        },
        {
            id: 'Persona-7979',
            name: 'Persona #7979',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-6132471537277302290.jpeg',
            price: '0.31 ETH'
        },
        {
            id: 'Persona-7980',
            name: 'Persona #7980',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-5256134164122790733.jpeg',
            price: '0.75 ETH'
        },
        {
            id: 'Persona-7977',
            name: 'Persona #7977',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-5837600618363619676.jpeg',
            price: '0.17 ETH'
        },
        {
            id: 'Persona-7978',
            name: 'Persona #7978',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-527322791259867962.jpeg',
            price: '0.55 ETH'
        },
        {
            id: 'Persona-7976',
            name: 'Persona #7976',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-7632428343217071674.jpeg',
            price: '0.25 ETH'
        },
        {
            id: 'Persona-7975',
            name: 'Persona #7975',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-4084828042735525331.jpeg',
            price: '0.69 ETH'
        },
        {
            id: 'Persona-7974',
            name: 'Persona #7974',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-3470227769587907031.jpeg',
            price: '0.14 ETH'
        },
        {
            id: 'Persona-7972',
            name: 'Persona #7972',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-447250134457934134.jpeg',
            price: '0.51 ETH'
        },
        {
            id: 'Persona-7973',
            name: 'Persona #7973',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-5612909555875143720.jpeg',
            price: '0.34 ETH'
        },
        {
            id: 'Persona-7970',
            name: 'Persona #7970',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-485252224953432106.jpeg',
            price: '0.73 ETH'
        },
        {
            id: 'Persona-7971',
            name: 'Persona #7971',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-8199381026660412628.jpeg',
            price: '0.18 ETH'
        },
        {
            id: 'Persona-7969',
            name: 'Persona #7969',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-3853858096586372764.jpeg',
            price: '0.57 ETH'
        },
        {
            id: 'Persona-7968',
            name: 'Persona #7968',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-7611096987109660233.jpeg',
            price: '0.28 ETH'
        },
        {
            id: 'Persona-7967',
            name: 'Persona #7967',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-5997399366946168313.jpeg',
            price: '0.66 ETH'
        },
        {
            id: 'Persona-7966',
            name: 'Persona #7966',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-6569500053315002909.jpeg',
            price: '0.13 ETH'
        },
        {
            id: 'Persona-7965',
            name: 'Persona #7965',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-7378222286262828995.jpeg',
            price: '0.49 ETH'
        },
        {
            id: 'Persona-7964',
            name: 'Persona #7964',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-8276565573035858655.jpeg',
            price: '0.32 ETH'
        },
        {
            id: 'Persona-7963',
            name: 'Persona #7963',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-4931240125955631535.jpeg',
            price: '0.77 ETH'
        },
        {
            id: 'Persona-7962',
            name: 'Persona #7962',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-8625648512596629164.jpeg',
            price: '0.16 ETH'
        },
        {
            id: 'Persona-7961',
            name: 'Persona #7961',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-5120565012498149422.jpeg',
            price: '0.54 ETH'
        },
        {
            id: 'Persona-7960',
            name: 'Persona #7960',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-6978523316225124349.jpeg',
            price: '0.24 ETH'
        },
        {
            id: 'Persona-7959',
            name: 'Persona #7959',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1708508308-999939157171544791.gif',
            price: '0.68 ETH'
        },
        {
            id: 'Persona-7958',
            name: 'Persona #7958',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715438-3213247545731912742.jpeg',
            price: '0.11 ETH'
        },
        {
            id: 'Persona-7957',
            name: 'Persona #7957',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715437-3752831694556275650.jpeg',
            price: '0.47 ETH'
        },
        {
            id: 'Persona-7956',
            name: 'Persona #7956',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715437-843542047110724712.jpeg',
            price: '0.29 ETH'
        },
        {
            id: 'Persona-7955',
            name: 'Persona #7955',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715437-4070073050664259159.jpeg',
            price: '0.72 ETH'
        },
        {
            id: 'Persona-7954',
            name: 'Persona #7954',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715437-4195160562789378184.jpeg',
            price: '0.15 ETH'
        },
        {
            id: 'Persona-7953',
            name: 'Persona #7953',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715437-4981707297528830895.jpeg',
            price: '0.53 ETH'
        },
        {
            id: 'Persona-7952',
            name: 'Persona #7952',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715437-6805005265672371537.jpeg',
            price: '0.26 ETH'
        },
        {
            id: 'Persona-7951',
            name: 'Persona #7951',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715437-8051506066306175944.jpeg',
            price: '0.65 ETH'
        },
        {
            id: 'Persona-7950',
            name: 'Persona #7950',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715437-6022840513157725324.jpeg',
            price: '0.12 ETH'
        },
        {
            id: 'Persona-7949',
            name: 'Persona #7949',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715437-1886106657916211840.jpeg',
            price: '0.46 ETH'
        },
        {
            id: 'Persona-7948',
            name: 'Persona #7948',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715437-3003590404607041275.jpeg',
            price: '0.30 ETH'
        },
        {
            id: 'Persona-7947',
            name: 'Persona #7947',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715437-2012908098688212376.jpeg',
            price: '0.74 ETH'
        },
        {
            id: 'Persona-7946',
            name: 'Persona #7946',
            image: 'https://resources.xter.io/funfog_upload/612262dd16bd/nft/1711715437-3873074243291856963.jpeg',
            price: '0.17 ETH'
        }
    
];